import { Radio, useTheme } from "@material-ui/core";
import { Label } from "@radix-ui/react-label";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import React from "react";

import { RadioGroupItem } from "@/features/common/components/tailwind/RadioGroup";

type CardPaymentProps = {
  showRadioButton?: boolean;
  userPaymentMethodId: string;
  lastFourDigits;
  brand;
  expMonth;
  expYear;
};
export const CardPayment: React.FC<CardPaymentProps> = (props) => {
  const { t } = useTranslation("subscriptionPlan");

  const {
    lastFourDigits,
    brand,
    expMonth,
    expYear,
    userPaymentMethodId,
    showRadioButton = true,
  } = props;

  return (
    <div className="w-full flex flex-col md:flex-row md:space-x-3">
      <div className="flex items-center">
        {showRadioButton && (
          <RadioGroupItem
            value={userPaymentMethodId}
            id={userPaymentMethodId}
            aria-label={`a card with last four digit ${lastFourDigits}`}
          />
        )}

        {/* card no. */}
        <Label
          htmlFor={userPaymentMethodId}
          className="text-gray-900 text-base touchable"
        >{`**** **** **** ${lastFourDigits}`}</Label>
      </div>

      {/* exp date and icon */}
      <div
        className={clsx(
          "flex items-center gap-2",
          showRadioButton && "pl-10 md:pl-0",
        )}
      >
        <span className="text-gray-500 text-base ">
          {t("subscriptionPlan:paymentMethodExpireDate", {
            expMonth,
            expYear,
          })}
        </span>

        <Image
          alt={brand}
          layout="fixed"
          width={27}
          height={20}
          src={`/assets/cardBrand/${brand}.png`}
        />
      </div>
    </div>
  );
};
